import { SingleEventHandler } from '@edreamsodigeo/frontend-core';
export const FARE_RULES_LOADED = 'frontend-shell:flexibility-bundle:loaded';
export const FARE_RULE_SELECT = 'frontend-shell:flexibility-bundle:onSelect';
export const NAVIGATE_TO_PAX = 'frontend-shell:flexibility-bundle:navigateToPax';
export const createfareRulesHandlers = () => ({
  onFareRulesLoaded() {
    var _window;
    (_window = window) === null || _window === void 0 || (_window = _window.Odigeo) === null || _window === void 0 || _window.trigger(FARE_RULES_LOADED);
  },
  onFareRuleSelect(fareRuleSelected) {
    var _window2;
    (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.Odigeo) === null || _window2 === void 0 || _window2.trigger(FARE_RULE_SELECT, fareRuleSelected);
  },
  onNavigateToPax(forceReload) {
    var _window3;
    (_window3 = window) === null || _window3 === void 0 || (_window3 = _window3.Odigeo) === null || _window3 === void 0 || _window3.trigger(NAVIGATE_TO_PAX, forceReload);
  },
  eventHandler: SingleEventHandler()
});